import { render, staticRenderFns } from "./BaseStatus.vue?vue&type=template&id=90c0f46e&scoped=true&"
import script from "./BaseStatus.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseStatus.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseStatus.vue?vue&type=style&index=0&id=90c0f46e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0f46e",
  null
  
)

export default component.exports